'use client';
import { useEffect } from 'react';

// Спиннер (next/image) на: фото машин (/photos/ + shared-сток /images/stock/),
// новостях (/images/news/), темах (/images/themes/) и городах (/images/cities/ —
// карусель + блок станций). Классы, декор /images/home/, иконки, лого — без лоадера.
const NEEDS_LOADER = /\/(photos\/|images\/(stock|news|themes|cities)\/)/i;
const needsLoader = (s: string) => { try { return NEEDS_LOADER.test(decodeURIComponent(s)); } catch { return NEEDS_LOADER.test(s); } };

export default function ImgLoaderGlobal() {
  useEffect(() => {
    const mark = (img: HTMLImageElement) => {
      if (img.dataset.nimgL) return;
      img.dataset.nimgL = '1';
      const src = img.currentSrc || img.src || img.getAttribute('src') || '';
      if (!needsLoader(src)) return; // не наша картинка — спиннер не вешаем вовсе
      const wrap = img.parentElement; // у next/image fill родитель — позиц. обёртка
      img.classList.add('nimg-fade'); // прячем фото (opacity:0), пока грузится
      wrap?.classList.add('nimg-load'); // спиннер живёт на обёртке
      const done = () => { img.classList.add('nimg-done'); wrap?.classList.remove('nimg-load'); };
      if (img.complete) done(); // complete = загружено ИЛИ ошибка — показываем целиком
      else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    };
    document.querySelectorAll<HTMLImageElement>('img[data-nimg]').forEach(mark);
    const obs = new MutationObserver((muts) => {
      for (const m of muts) for (const n of m.addedNodes) {
        if (n instanceof HTMLImageElement) { if (n.hasAttribute('data-nimg')) mark(n); }
        else if (n instanceof HTMLElement) n.querySelectorAll<HTMLImageElement>('img[data-nimg]').forEach(mark);
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);
  return null;
}
